export const LOGIN = 'LOGIN';
export const HOME = 'HOME';
export const JOBS = 'JOBS';
export const DEFAULT = 'DEFAULT';
export const JOBS_TV = 'JOBS_TV';
export const BFIX_DASH = 'BFIX_DASH';
export const AIR_ROAD_JOBS = 'AIR_ROAD_JOBS';
export const AIR_ROAD_JOBS_NEW = 'AIR_ROAD_JOBS_NEW';
export const AIR_ROAD_BOOKED = 'AIR_ROAD_BOOKED';
export const JOB_TICKETS = 'JOB_TICKETS';
export const JOB_BOOKING = 'JOB_BOOKING';
export const BOOKING_COMPLIANCE = 'BOOKING_COMPLIANCE';
export const PARCEL_JOB_BOOKING = 'PARCEL_JOB_BOOKING';
export const NEW_JOB_BOOKING = 'NEW_JOB_BOOKING';
export const ADVANCED_JOB_BOOKING = 'ADVANCED_JOB_BOOKING';
export const DRAFT_ADVANCED_JOB_BOOKING = 'DRAFT_ADVANCED_JOB_BOOKING';
export const PAC_JOB_BOOKING = 'PAC_JOB_BOOKING';
export const DRAFT_PAC_JOB_BOOKING = 'DRAFT_PAC_JOB_BOOKING';
export const PAC_PALLET_JOB_BOOKING = 'PAC_PALLET_JOB_BOOKING';
export const PAC_BOOK_BOXES_JOB_BOOKING = 'PAC_BOOK_BOXES_JOB_BOOKING';
export const SPREADSHEET_JOB_BOOKING = 'SPREADSHEET_JOB_BOOKING';
export const SPREADSHEET_B2B_BOOKING = 'SPREADSHEET_B2B_BOOKING';
export const SEARCH = 'SEARCH';
export const SEARCH_JOB_ID = 'SEARCH_JOB_ID';
export const SEARCH_ADVANCED = 'SEARCH_ADVANCED';
export const SEARCH_POSTCODE = 'SEARCH_POSTCODE';
export const SEARCH_SUBURBS = 'SEARCH_SUBURBS';
export const DRAFT_JOB_BOOKING = 'DRAFT_JOB_BOOKING';
export const WAREHOUSE_QUANT_PAGE = 'WAREHOUSE_QUANT_PAGE';
export const DETAILED_QUERY_JOB = 'DETAILED_QUERY_JOB';
export const DETAILED_PARAM_JOB = 'DETAILED_PARAM_JOB';
export const TICKET_FROM_THE_SERVICE_DESK = 'TICKET_FROM_THE_SERVICE_DESK';
export const SERVICE_DESK_TICKET = 'SERVICE_DESK_TICKET';
export const LIST_QUOTES = 'LIST_QUOTES';
export const NEW_QUOTE = 'NEW_QUOTE';
export const DETAILED_QUOTE = 'DETAILED_QUOTE';
export const SCHEDULER_BOARD = 'SCHEDULER_BOARD';
export const SCHEDULER_BOARD_LOGS = 'SCHEDULER_BOARD_LOGS';
export const SCHEDULER = 'SCHEDULER';
export const SCHEDULER_SHIFTS = 'SCHEDULER_SHIFTS';
export const PROFILE = 'PROFILE';
export const PROFILE_NOTIFICATIONS = 'PROFILE_NOTIFICATIONS';
export const PROFILE_SETTINGS = 'PROFILE_SETTINGS';
export const ADDRESS_BOOK = 'ADDRESS_BOOK';
export const REPORTS = 'REPORTS';
export const RUN_SHEET = 'RUN_SHEET';
export const KPI_REPORT = 'KPI_REPORT';
export const DRIVER_REPORT = 'DRIVER_REPORT';
export const TOMORROW_REPORT = 'TOMORROW_REPORT';
export const WEEKLY_STATS_REPORT = 'WEEKLY_STATS_REPORT';
export const OLD_VERSION = 'OLD_VERSION';
export const AM_PM_JOBS = 'AM_PM_JOBS';
export const ETA_REPORT = 'ETA_REPORT';
export const BOOKED_JOBS = 'BOOKED_JOBS';
export const JOB_EDIT = 'JOB_EDIT';
export const INITIAL_ERROR = 'INITIAL_ERROR';
export const PAGE_ERROR = 'PAGE_ERROR';
export const LOCATIONS = 'LOCATIONS';
export const JOB_HISTORY = 'JOB_HISTORY';
export const SMS_DAILY_FOLLOW_UP = 'SMS_DAILY_FOLLOW_UP';
export const SMS_HISTORY = 'SMS_HISTORY';
export const SMS_CHAT = 'SMS_CHAT';
export const DISPATCH = 'DISPATCH';
